export function sortItemsBySide(items) {
  const sideOrder = {
    left: 0,
    right: 1,
    top: 2,
    bottom: 3,
  };

  // Sort the items based on the side property
  items.sort((a, b) => sideOrder[a.side] - sideOrder[b.side]);

  return items;
}
